module.exports = __webpack_public_path__ + "static/media/abn-service.30c11e48.jpg";